var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg/grid"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7802",
    x: 3.65,
    y: 3.65,
    width: 16.7,
    height: 6.7,
    rx: 1.35,
    stroke: "#46474C",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7803",
    x: 3.65,
    y: 13.65,
    width: 16.7,
    height: 6.7,
    rx: 1.35,
    stroke: "#46474C",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuProduct);
export default __webpack_public_path__ + "static/media/icon_menu_product.c4061e55ca7cd9756a86b7e8db8ec35a.svg";
export { ForwardRef as ReactComponent };